/**
 * reason.ts — Quy tắc lý do thao tác Platform (khớp backend parseReason, tiêu chuẩn test C14).
 * Bắt buộc: ≥ 3 ký tự. Tuỳ chọn: để trống HOẶC ≥ 3 ký tự — FE báo trước, không gửi 1–2 ký tự.
 */
export const REASON_MIN = 3

export function reasonError(reason: string, required: boolean): string | null {
  const t = reason.trim()
  if (!t) return required ? 'Vui lòng nhập lý do' : null
  if (t.length < REASON_MIN) return `Lý do tối thiểu ${REASON_MIN} ký tự${required ? '' : ' (hoặc để trống)'}`
  return null
}
